import React, { Component } from 'react';
import './SendOverlay.css';
import { sendMessage } from '../../../../../../api';
import { TEXT } from '../../../../../../content';

const LS_KEYS = {
  NAME: 'rekonstrukce-send-name',
  CONTACT: 'rekonstrukce-send-contact',
};

class SendOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sending: false,
      sendComplete: false,
      name: localStorage.getItem(LS_KEYS.NAME) || '',
      contact: localStorage.getItem(LS_KEYS.CONTACT) || '',
    };

    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeContact = this.handleChangeContact.bind(this);
    this.handleSend = this.handleSend.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  // -----------------------------------------------------------------------------------
  // Sending
  // -----------------------------------------------------------------------------------

  handleSend() {
    const { name, contact } = this.state;

    // disable form
    this.setState({
      sending: true,
    });

    // try to send
    sendMessage(name, contact)
      .then(() => {
        // save values for next possible form
        localStorage.setItem(LS_KEYS.NAME, name);
        localStorage.setItem(LS_KEYS.CONTACT, contact);
        // continue
        this.sendOk();
      })
      .catch(() => {
        this.sendError();
      });
  }

  sendOk() {
    this.setState({
      sending: false,
      sendComplete: true,
    });
  }

  sendError() {
    // note - show error message
    this.setState({
      sending: false,
    });
  }

  // -----------------------------------------------------------------------------------
  // Handlers
  // -----------------------------------------------------------------------------------

  handleChangeName(e) {
    this.setState({
      name: e.target.value,
    });
  }

  handleChangeContact(e) {
    this.setState({
      contact: e.target.value,
    });
  }

  handleClose() {
    const { sendComplete } = this.state;
    const { sendClose } = this.props;
    sendClose(sendComplete); // reset forms if send is complete
    this.setState({
      sendComplete: false,
    });
  }

  // -----------------------------------------------------------------------------------
  // Render
  // -----------------------------------------------------------------------------------

  formContent() {
    const { name, contact, sending } = this.state;
    return (
      <React.Fragment>
        <div className="send-block">
          <p className="sb-500">{TEXT.SEND_OVER_TITLE}</p>
          <p>{TEXT.SEND_OVER_NAME}</p>
          <input
            id="i-0"
            type="text"
            maxLength="64"
            onChange={this.handleChangeName}
            value={name}
            disabled={sending}
            placeholder={TEXT.NAME_PLACEHOLDER}
          />
        </div>
        <div className="send-block">
          <p>{TEXT.SEND_OVER_CONTACT}</p>
          <input
            id="i-2"
            type="text"
            maxLength="64"
            onChange={this.handleChangeContact}
            value={contact}
            disabled={sending}
          />
        </div>
        <div className="send-block">
          <button type="button" onClick={this.handleSend} disabled={sending}>
            {TEXT.SEND_OVER_SEND}
          </button>
          <button
            id="send-cancel-button"
            className="secondary"
            type="button"
            onClick={this.handleClose}
            disabled={sending}
          >
            {TEXT.SEND_OVER_CANCEL}
          </button>
        </div>
      </React.Fragment>
    );
  }

  completeContent() {
    return (
      <React.Fragment>
        <div className="send-block">{TEXT.SEND_OVER_OK_TITLE_0}</div>
        <div className="send-block sb-500">{TEXT.SEND_OVER_OK_TITLE_1}</div>
        <div className="send-block">
          <button type="button" onClick={this.handleClose}>
            {TEXT.SEND_OVER_OK_CONTINUE}
          </button>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { sendComplete } = this.state;

    return (
      <div id="send-overlay">
        <div id="send-overlay-wrap">
          {!sendComplete && this.formContent()}
          {sendComplete && this.completeContent()}
        </div>
      </div>
    );
  }
}

export default SendOverlay;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/SendOverlay/SendOverlay.js